/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
// Elements
import { Link } from 'gatsby';
import {
  Navbar, Nav, Container, Button, NavDropdown,
} from 'react-bootstrap';
import { StaticImage } from 'gatsby-plugin-image';

function Navigation() {
  return (
    <div>
      <Navbar variant="light" bg="white" expand="xl" className="pt-4 shadow-6" fixed="top">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <StaticImage src="../images/logo.svg" className="logo" alt="logo" loading="eager" formats={['jpg', 'webp']} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto mr-2">
              <Nav.Link as={Link} to="/">
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/about/">
                About
              </Nav.Link>
              <Nav.Link as={Link} to="/bricks/">
                Bricks
              </Nav.Link>
              <Nav.Link as={Link} to="/cladding-facade-tiles/">
                Cladding Tiles
              </Nav.Link>
              <Nav.Link as={Link} to="/arches-and-specials/">
                Specials
              </Nav.Link>
              <NavDropdown
                id="businesses-dropdown"
                title="Businesses"
                menuVariant="light"
                drop="down-centered"
                className="me-0"
              >
                <NavDropdown.Item as={Link} to="/business/architects/" className="fw-bold text-uppercase">Architects</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/business/builders-merchants/" className="fw-bold text-uppercase">Builders&apos; Merchants</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/business/builders/" className="fw-bold text-uppercase">Builders</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/business/contractors/" className="fw-bold text-uppercase">Contractors</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link as={Link} to="/projects/">
                Projects
              </Nav.Link>
              <NavDropdown
                id="resources-dropdown"
                title="Resources"
                menuVariant="light"
                drop="down-centered"
              >
                <NavDropdown.Item as={Link} to="/resources/brick-calculator/" className="fw-bold text-uppercase">Brick Calculator</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/resources/brick-match/" className="fw-bold text-uppercase">Brick Match Service</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/resources/cpd-presentation/" className="fw-bold text-uppercase">CPD Presentation</NavDropdown.Item>
              </NavDropdown>
              <Button variant="warning" as={Link} to="/contact/" className="shake ms-lg-2">Contact</Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className="mt-5 mb-5 pt-2 pb-2" />
    </div>
  );
}

export default Navigation;
